import { render, staticRenderFns } from "./RegistrationDash.vue?vue&type=template&id=7ba9dc75&"
import script from "./RegistrationDash.vue?vue&type=script&lang=js&"
export * from "./RegistrationDash.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationDash.vue?vue&type=style&index=0&id=7ba9dc75&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports